import React from "react";
import {
  MenuItem,
  Select,
  SelectProps,
  FormControl,
  InputLabel,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import FormField from "@modules/formx-react/FormField";

type Props = {
  name: string;
  label?: string;
  required?: boolean;
  clearable?: boolean;
  options: LabelValue[];
  selectProps?: Partial<SelectProps>;
};

export function SimpleSelect(props: Props) {
  return (
    <FormField name={props.name}>
      {(field) => {
        const label = field.error || props.label;
        const disabled = field.disabled;
        const hasValue = field.value !== null && field.value !== "";

        const handleClear = (event: React.MouseEvent) => {
          event.stopPropagation();
          event.preventDefault();

          field.fieldProps.onChange(null);
        };

        return (
          <FormControl
            disabled={disabled}
            required={props.required}
            fullWidth
            error={!!field.error}
          >
            {label && <InputLabel>{label}</InputLabel>}

            <Select
              {...field.fieldProps}
              {...props.selectProps}
              endAdornment={
                props.clearable && hasValue && !disabled ? (
                  <InputAdornment position="end" style={{ marginRight: "1.3rem" }}>
                    <IconButton size="small" onClick={handleClear}>
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : undefined
              }
            >
              {props.options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      }}
    </FormField>
  );
}
